module.exports = __webpack_public_path__ + "static/media/aws_logo.5368e759.png";